var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUserCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Copy@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC65-Student-Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Student-Management-/-Student-Profile-/-Reports-Package-3",
    transform: "translate(-120.000000, -288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stats-1",
    transform: "translate(96.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Copy",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    fill: "#172E4B",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/User-Check/Multicolour/Gray",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6852497,8.7465 L22.6852498,8.74650001 C22.8386789,8.90489888 22.8371788,9.15693713 22.6818748,9.31350001 L17.9129998,14.04525 L17.9129998,14.04525 C17.7560123,14.2008939 17.5025761,14.1998044 17.3469313,14.0428171 C17.3466204,14.0425036 17.3463101,14.0421895 17.3460004,14.041875 L14.5886254,11.26425 L14.5886254,11.26425 C14.4329815,11.1072626 14.4340709,10.8538264 14.5910583,10.6981815 C14.5913718,10.6978707 14.5916858,10.6975604 14.5920004,10.6972506 L15.5403754,9.75562561 L15.5403754,9.75562561 C15.6973628,9.59998175 15.950799,9.6010712 16.1064439,9.75805857 C16.1067547,9.75837207 16.107065,9.75868609 16.1073748,9.75900061 L17.6429998,11.3047506 L21.1799998,7.79475061 L21.1799998,7.79475061 C21.3369872,7.63910675 21.5904234,7.6401962 21.7460683,7.79718357 C21.7463791,7.79749707 21.7466894,7.79781109 21.7469992,7.79812562 L22.6852497,8.7465 Z",
    id: "Secondary",
    fill: "#4C69BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75999975,12.0000007 L8.75999956,12.0000007 C11.1458681,12.0000007 13.0799996,10.0658719 13.0799996,7.68 C13.0799996,5.2941315 11.1458714,3.36 8.75999956,3.36 C6.37413106,3.36 4.43999956,5.29412813 4.43999956,7.68 L4.43999956,7.68000065 C4.43999956,10.0658692 6.37413106,12.0000007 8.75999956,12.0000007 L8.75999975,12.0000007 Z M11.7839997,13.08 L11.2203747,13.08 L11.2203748,13.08 C9.65913354,13.7999786 7.86086604,13.7999786 6.29962479,13.08 L5.73599979,13.08 L5.736,13.08 C3.23106825,13.0805588 1.20057375,15.1110683 1.2,17.616 L1.2,19.02 L1.2,19.0200003 C1.2,19.9147026 1.92529762,20.6400003 2.82,20.6400003 L14.7,20.6400003 L14.7,20.6400003 C15.5947023,20.6400003 16.32,19.9147026 16.32,19.0200003 L16.32,17.6160003 L16.32,17.6170126 C16.32,15.1120808 14.2899443,13.0811138 11.7850125,13.08 L11.7839997,13.08 Z",
    id: "Primary",
    fill: "#4C69BA"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserCheck);
export default __webpack_public_path__ + "static/media/icon-user-check.9b9e526c.svg";
export { ForwardRef as ReactComponent };